import React, { useState } from 'react';
import frame from '../../../assets/images/four-fram.png';
import ImagePaging from './image-slider';
import ProductItems from './product-slider';
import {
  TickOneIcon,
  OneFacebookIcon,
  OneInstagramIcon,
  OneTikTokIcon,
} from '../../atoms/icons';
import VideoPaging from './video-slider';
import defaultAvatar from '../../../assets/images/default-avatar.jpg';

export const TemplateFour = ({
  expertiseData,
  preferredBrands,
  preferredProducts,
  redirectToBuyerPortal,
  redirectToShopPortal,
  cardDetails,
  schedulerEnabled,
}) => {
  const { seller, storefront } = cardDetails?.current?.config;

  const LogoUrl =
    storefront?.general?.longLogoImage?.url ||
    storefront?.general?.logoImage?.url ||
    null;

  const [isExpanded, setIsExpanded] = useState(false);
  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      <div className="four-wrapper ">
        <header>
          <section className="flex justify-between items-center gap-6 head-sec  px-4 py-2.5">
            {LogoUrl ? (
              <div className="logo-box max-w-56">
                <img src={LogoUrl} alt="logo" />
              </div>
            ) : (
              <h2 className="logo-text pl-1 text-fourPrimary capitalize">
                {storefront?.general?.name}
              </h2>
            )}
          </section>
          <div className="top-sec md:flex-row flex-col">
            <div className="relative image-box">
              <img
                src={frame}
                alt="frame"
                className=" absolute md:-left-8 md:top-8 -left-5 top-4 frame"
              />
              <img
                src={
                  seller?.profile?.avatar?.mediumUrl ||
                  seller?.profile?.avatar?.url ||
                  defaultAvatar
                }
                alt="icon"
                className="relative z-10 profilebg"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = defaultAvatar;
                }}
              />
            </div>
            <div className="mob-four">
              <div className="mobile-view">
                <h2 className="text-fourPrimary font-bold md:text-6xl text-4xl font-tempOne capitalize  break-words">
                  {seller?.profile?.title}
                </h2>

                <div className="long-text">
                  <div
                    className={
                      isExpanded
                        ? 'full-text'
                        : seller?.profile?.about?.length > 600
                        ? 'clamped-text'
                        : ''
                    }
                  >
                    <p
                      className="font-bold text-xl mt-5 font-tempOne after:border-twoPrimary text-[#585858]"
                      dangerouslySetInnerHTML={{
                        __html: seller?.profile?.about,
                      }}
                    />
                  </div>
                  {seller?.profile?.about?.length > 600 && (
                    <div className="text-right">
                      <button
                        className="text-fourPrimary read-text"
                        onClick={toggleReadMore}
                      >
                        {isExpanded ? 'Read Less' : 'Read More'}
                      </button>
                    </div>
                  )}
                </div>
                <div className="flex gap-4  items-center mt-5">
                  {seller?.profile?.facebookUrl && (
                    <a
                      href={seller?.profile?.facebookUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cursor-pointer"
                    >
                      <OneFacebookIcon className="text-fourPrimary" />
                    </a>
                  )}
                  {seller?.profile?.instagramUrl && (
                    <a
                      href={seller?.profile?.instagramUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cursor-pointer"
                    >
                      <OneInstagramIcon className="text-fourPrimary" />
                    </a>
                  )}
                  {seller?.profile?.tiktokUrl && (
                    <a
                      href={seller?.profile?.tiktokUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cursor-pointer"
                    >
                      <OneTikTokIcon className="text-fourPrimary" />
                    </a>
                  )}
                </div>
                <button
                  className="text-white-main font-normal text-xl mt-10 px-10 py-5 rounded-ThreeCustom bg-fourPrimary"
                  onClick={() =>
                    redirectToShopPortal(storefront?.general?.shopUrl)
                  }
                >
                  Shop the store
                </button>
              </div>
            </div>
          </div>
        </header>
        <section className="four-body">
          <div className="four-Inner-body">
            <div className="Expertise-box-wrp text-center">
              {expertiseData?.length > 0 ? (
                <>
                  <h2 className="text-fivePrimary font-semibold md:text-4xl text-2xl font-tempOne md:mt-7 mt-14 mb-7">
                    Expertise
                  </h2>
                  <ul className="grid md:gap-8 gap-4 four-list">
                    {expertiseData.map((item, index) => (
                      <li key={index}>
                        <TickOneIcon className="text-fourPrimary" />
                        <span className="ml-2.5 font-normal text-base">
                          {item?.name}
                        </span>
                      </li>
                    ))}
                  </ul>
                </>
              ) : seller?.profile?.expertise ? (
                <>
                  <h2 className="text-fivePrimary font-semibold md:text-4xl text-2xl font-tempOne md:mt-7 mt-14 mb-7">
                    Expertise
                  </h2>
                  <p
                    className="mt-5 font-tempOne border-onePrimary text-base"
                    dangerouslySetInnerHTML={{
                      __html: seller?.profile?.expertise,
                    }}
                  />
                </>
              ) : null}

              {schedulerEnabled && (
                <button
                  className="text-white-main font-normal  text-xl mt-10  px-10 py-5 rounded-ThreeCustom bg-fourPrimary"
                  onClick={() => redirectToBuyerPortal()}
                >
                  Book an appointment
                </button>
              )}
            </div>
            {seller?.profile?.galleryImages?.length ? (
              <div className="md:mt-10 md:mx-0 -mx-4 imageSlider-box">
                <h2 className=" text-fivePrimary text-center font-normal md:text-4xl text-2xl font-tempOne mt-7 mb-5">
                  <strong className="font-extrabold font-tempOne">Salon</strong>{' '}
                  Gallery
                </h2>
                <ImagePaging images={seller?.profile?.galleryImages} />
              </div>
            ) : (
              <></>
            )}
            {seller?.profile?.galleryVideoLinks?.length ? (
              <>
                <div className="md:mt-10 mt-16 md:mx-0 -mx-4 imageSlider-box">
                  <h2 className=" text-fivePrimary text-center font-normal md:text-4xl text-2xl font-tempOne mt-7 mb-5">
                    <strong className="font-extrabold font-tempOne">
                      {' '}
                      Salon
                    </strong>
                    Videos
                  </h2>
                  <VideoPaging videos={seller?.profile?.galleryVideoLinks} />
                </div>
              </>
            ) : (
              <></>
            )}
            {(preferredProducts?.length > 0 || preferredBrands?.length > 0) && (
              <div className="md:mt-10 mt-14 text-center">
                {preferredProducts?.length > 0 ? (
                  <>
                    <h2 className="text-fivePrimary text-center font-normal md:text-4xl text-2xl font-tempOne mt-7 mb-5">
                      My Favorite{' '}
                      <strong className="font-extrabold">Products</strong>
                    </h2>
                    <ProductItems
                      preferredProducts={preferredProducts}
                      storefront={storefront}
                    />
                  </>
                ) : (
                  <>
                    <h2 className="text-fivePrimary text-center font-normal md:text-4xl text-2xl font-tempOne mt-7 mb-5">
                      My Favorite{' '}
                      <strong className="font-extrabold">Brands</strong>
                    </h2>
                    <ProductItems
                      preferredBrands={preferredBrands}
                      storefront={storefront}
                    />
                  </>
                )}
              </div>
            )}
          </div>
        </section>
      </div>
    </>
  );
};
